<template>
  <Card class="layout-card" style="height: 100%">
    <div class="push-setting-page">
      <Tabs v-model="activeTab">
        <TabPane label="活动推送" name="popup-push" />
        <TabPane label="H5活动推送" name="h5-activity-push" />
      </Tabs>

      <div v-show="activeTab === 'popup-push'" class="push-tab-content">
          <div class="header-container">
            <div class="filter-row">
              <Select
                v-model="searchForm.popupId"
                placeholder="请选择推送弹窗"
                clearable
                filterable
                remote
                :remote-method="searchPopups"
                :loading="popupLoading"
                class="filter-item"
              >
                <Option
                  v-for="item in popupOptions"
                  :key="item.id"
                  :value="item.id"
                  :label="item.popupName"
                >
                  {{ item.popupName }}
                </Option>
              </Select>

              <Select
                v-model="searchForm.crowdId"
                placeholder="请选择人群包"
                clearable
                filterable
                :loading="crowdLoading"
                class="filter-item"
              >
                <Option
                  v-for="item in crowdOptions"
                  :key="item.id"
                  :value="item.id"
                  :label="item.name"
                >
                  {{ item.name }}
                </Option>
              </Select>

              <Select
                v-model="searchForm.position"
                placeholder="请选择触发页面"
                clearable
                class="filter-item filter-item--trigger-scene"
              >
                <Option
                  v-for="item in triggerPageOptions"
                  :key="item.dictValue"
                  :value="Number(item.dictValue)"
                >
                  {{ item.dictName }}
                </Option>
              </Select>

              <Select
                v-model="searchForm.status"
                placeholder="请选择开启状态"
                clearable
                class="filter-item"
              >
                <Option :value="1">开启</Option>
                <Option :value="0">关闭</Option>
              </Select>

              <Input
                v-model="searchForm.popupRuleName"
                placeholder="请输入推送规则名称搜索"
                clearable
                class="filter-item"
              />

              <Button type="primary" @click="getData(1)">搜索</Button>
              <Button @click="handleReset">重置</Button>
              <Button type="primary" @click="handleOpenEditModal()" class="btn-add">
                新增
              </Button>
            </div>
          </div>

          <div class="table-container">
            <Table :data="tableData" :columns="columns" :loading="tableLoading">
              <template #ruleName="{ row }">
                <div>
                  <div>{{ row.popupRuleName }}</div>
                  <div class="id-text">id: {{ row.showId }}</div>
                </div>
              </template>

              <template #popupName="{ row }">
                <span>{{ row.popupName || '-' }}</span>
              </template>

              <template #crowdNames="{ row }">
                <span>{{ row.crowdNames || '不限' }}</span>
              </template>

              <template #popupCount="{ row }">
                <span>{{ row.popupCount === 0 ? '不限' : row.popupCount }}</span>
              </template>

              <template #status="{ row }">
                <i-switch
                  :key="row.id"
                  :value="Number(row.status)"
                  :true-value="1"
                  :false-value="0"
                  :disabled="tableLoading || Boolean(statusChangingId)"
                  :loading="statusChangingId === row.id"
                  @on-change="(val) => handleStatusChange(row, val)"
                />
              </template>

              <template #action="{ row }">
                <div class="action-buttons">
                  <a @click="handleView(row)">查看</a>
                  <a @click="handleOpenEditModal(row)">编辑</a>
                  <a @click="handleDelete(row)">删除</a>
                </div>
              </template>

              <template #footer>
                <Pages :page="page" :func="getData"></Pages>
              </template>
            </Table>
          </div>
      </div>

      <H5ActivityPushList
        v-show="activeTab === 'h5-activity-push'"
        class="push-tab-content"
      />
    </div>

    <EditModal
      v-model="editVisible"
      :data="editForm"
      :readonly="editReadonly"
      @on-success="getData"
    />
  </Card>
</template>

<script>
import Pages from '@/components/pages'
import EditModal from './EditModal.vue'
import H5ActivityPushList from './H5ActivityPushList.vue'
import {
  getPushList,
  delPush,
  getPushInfo,
  changePushStatus
} from '@/api/crowdPush'
import { getCrowdList } from '@/api/crowd'
import { getPopupList } from '@/api/popup'
import { getDictionaryList } from '@/api/dictionary'

export default {
  name: 'PushSettingList',
  components: {
    Pages,
    EditModal,
    H5ActivityPushList
  },
  data() {
    return {
      activeTab: 'popup-push',
      searchForm: {
        popupRuleName: '',
        status: '',
        crowdId: '',
        position: '',
        popupId: ''
      },
      tableLoading: false,
      statusChangingId: '',
      crowdLoading: false,
      popupLoading: false,
      editVisible: false,
      editReadonly: false,
      editForm: {},
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      tableData: [],
      triggerPageOptions: [],
      crowdOptions: [],
      popupOptions: [],
      columns: [
        {
          title: '推送规则名称',
          slot: 'ruleName',
          minWidth: 150
        },
        {
          title: '推送活动',
          slot: 'popupName',
          minWidth: 120
        },
        {
          title: '人群包',
          slot: 'crowdNames',
          tooltip: true,
          tooltipMaxWidth: 300,
          minWidth: 120
        },
        {
          title: '触发页面',
          key: 'positionName',
          minWidth: 140,
          render: (h, params) => {
            return <div>{params.row.positionName || '--'}</div>
          }
        },
        {
          title: '优先级',
          key: 'priority',
          minWidth: 60
        },
        {
          title: '每日触发次数',
          slot: 'popupCount',
          minWidth: 100,
          align: 'center'
        },
        {
          title: '状态',
          slot: 'status',
          width: 80,
          align: 'center'
        },
        {
          title: '操作',
          slot: 'action',
          width: 120,
          align: 'center'
        }
      ]
    }
  },
  methods: {
    async fetchDictionaries() {
      try {
        const { data } = await getDictionaryList({ dictTopic: 'POPUP_POSITION' })
        this.triggerPageOptions = data.records || []
      } catch (e) {
        console.error('获取字典数据失败', e)
      }
    },
    async fetchCrowdPackages() {
      this.crowdLoading = true
      try {
        const { data } = await getCrowdList({ current: -1, size: -1 })
        this.crowdOptions = data.records || []
      } catch (e) {
        console.error('获取人群包列表失败', e)
      } finally {
        this.crowdLoading = false
      }
    },
    async searchPopups(query) {
      this.popupLoading = true
      try {
        const { data } = await getPopupList({
          current: 1,
          size: 20,
          popupName: query
        })
        this.popupOptions = data.records || []
      } catch (e) {
        console.error('获取弹窗列表失败', e)
      } finally {
        this.popupLoading = false
      }
    },
    async getData(current) {
      if (current) this.page.current = current
      this.tableLoading = true
      try {
        const params = {
          current: this.page.current,
          size: this.page.size,
          popupRuleName: this.searchForm.popupRuleName || undefined,
          status:
            this.searchForm.status !== '' ? this.searchForm.status : undefined,
          crowdIds:
            this.searchForm.crowdId !== ''
              ? String(this.searchForm.crowdId)
              : undefined,
          crowdLimit: this.searchForm.crowdId !== '' ? 0 : undefined,
          positions:
            this.searchForm.position != null && this.searchForm.position !== ''
              ? String(this.searchForm.position)
              : undefined,
          popupId:
            this.searchForm.popupId !== '' ? this.searchForm.popupId : undefined
        }
        const { data } = await getPushList(params)
        this.tableData = data.records || []
        this.page.total = data.total || 0
      } catch (error) {
        this.$Message.error('获取列表失败')
      } finally {
        this.tableLoading = false
      }
    },
    handleReset() {
      this.searchForm = {
        popupRuleName: '',
        status: '',
        crowdId: '',
        position: '',
        popupId: ''
      }
      this.getData(1)
    },
    async handleOpenEditModal(row) {
      if (row) {
        try {
          this.tableLoading = true
          const { data } = await getPushInfo(row.id)
          this.editForm = data
          this.editReadonly = false
          this.editVisible = true
        } catch (error) {
          this.$Message.error('获取详情失败')
        } finally {
          this.tableLoading = false
        }
      } else {
        this.editForm = {}
        this.editReadonly = false
        this.editVisible = true
      }
    },
    async handleStatusChange(row, val) {
      if (this.tableLoading || this.statusChangingId) return

      const previousStatus = Number(row.status)
      const nextStatus = Number(val)
      if (previousStatus === nextStatus) return

      this.statusChangingId = row.id
      // 先让行数据与开关保持一致，请求失败时回滚，
      // 避免出现“开关已打开但后台没有生效”的假状态
      this.$set(row, 'status', nextStatus)

      try {
        await changePushStatus(row.id)
        this.$Message.success('状态切换成功')
        await this.getData(this.page.current)
      } catch (error) {
        this.$set(row, 'status', previousStatus)
        this.$Message.error('操作失败')
      } finally {
        this.statusChangingId = ''
      }
    },
    handleDelete(row) {
      this.$Modal.confirm({
        title: '提示',
        content: `是否确定删除该弹窗规则: "${row.popupRuleName}"?`,
        onOk: async () => {
          try {
            await delPush(row.id)
            this.$Message.success('删除成功')
            this.getData()
          } catch (error) {
            this.$Message.error('删除失败')
          }
        }
      })
    },
    async handleView(row) {
      try {
        this.tableLoading = true
        const { data } = await getPushInfo(row.id)
        this.editForm = data
        this.editReadonly = true
        this.editVisible = true
      } catch (error) {
        this.$Message.error('获取详情失败')
      } finally {
        this.tableLoading = false
      }
    }
  },
  mounted() {
    this.fetchDictionaries()
    this.fetchCrowdPackages()
    this.searchPopups('')
    this.getData()
  }
}
</script>

<style scoped lang="less">
.push-setting-page {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.push-tab-content {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.header-container {
  margin-bottom: 20px;
  flex-shrink: 0;
}

.filter-row {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  align-content: flex-start;
}

.filter-item {
  flex: 0 1 180px;
  min-width: 180px;
  max-width: 200px;
}

.filter-item--trigger-scene {
  flex-basis: 220px;
  min-width: 220px;
  max-width: 260px;
}

.btn-add {
  margin-left: auto;
}

.filter-row > .ivu-btn {
  flex-shrink: 0;
}

.id-text {
  color: #999;
  font-size: 12px;
}

.table-container {
  flex: 1;
  min-height: 0;
  overflow: auto;
}

.action-buttons {
  display: flex;
  justify-content: center;
  gap: 15px;

  a {
    color: #2d8cf0;

    &:hover {
      color: #57a3f3;
    }
  }
}

.layout-card {
  /deep/ .ivu-card-body {
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    padding: 20px;
  }
}

@media (max-width: 1320px) {
  .btn-add {
    margin-left: 0;
  }
}

@media (max-width: 960px) {
  .filter-item,
  .filter-item--trigger-scene {
    flex: 1 1 100%;
    min-width: 0;
    max-width: none;
  }
}
</style>
